import React from 'react'
import { Link } from 'react-router-dom';
import './App.css'
const Banner = ({title,subtitle,children}) => (
    <div className="banner">
        <h1>{title}</h1>
        <div/>
        <p><Link to="/shop">{subtitle}</Link></p>
        {children}
    </div>
)
export default Banner;